export default {
  methods: {
    buildSubmitPayload() {
      const orderData = {
        guid: this.requestData.guid,
        prod_no: this.requestData.prod_no,
        pkg_no: this.requestData.pkg_no,
        item_no: this.requestData.item_no,
        s_date: this.requestData.s_date,
        e_date: this.booking.e_date || this.requestData.e_date || this.requestData.s_date,
        event_time: this.requestData.event_time,
        skus: this.requestData.skus,
        total_price: this.requestData.total_price,
        b2c_total_price: this.requestData.b2c_total_price,
        locale: 'zh-tw',
        state: 'TW',
        buyer_tel_country_code: '86',
        buyer_tel_number: this.booking.buyer_tel_number,
        buyer_country: this.booking.buyer_country,
        buyer_first_name: this.booking.buyer_first_name,
        buyer_last_name: this.booking.buyer_last_name,
        buyer_Email: this.booking.buyer_Email,
        order_note: this.booking.order_note,
        partner_order_no: this.booking.partner_order_no,
        guide_lang: this.booking.guide_lang,
        pay_type: this.booking.pay_type || '01',
        custom: (this.booking.custom || []).map((item) => this.filterCustomerData(item)),
        traffic: this.booking.traffic || [],
        mobile_device: this.normalizeMobileDeviceData(this.booking.mobile_device, this.bookingField),
      };

      return {
        order_data: orderData,
        extra: this.requestData.extra || {},
      };
    },
    filterCustomerData(item) {
      const result = {
        cus_type: item.cus_type,
      };
      const config = this.bookingField && this.bookingField.custom ? this.bookingField.custom : {};
      Object.keys(config).forEach((key) => {
        if (key === 'cus_type' || !config[key] || typeof config[key] !== 'object') return;
        if (this.isFieldVisible(config[key], item.cus_type)) {
          result[key] = item[key];
        }
      });
      return result;
    },
    filterTrafficData(item) {
      const result = {
        traffic_type: item.traffic_type,
      };
      this.getVisibleTrafficFields(item.traffic_type).forEach((field) => {
        result[field.key] = item[field.key];
      });
      return result;
    },
    filterMobileDeviceData() {
      const result = {};
      this.mobileDeviceFields.forEach((field) => {
        result[field.key] = this.booking.mobile_device[field.key];
      });
      return result;
    },
    validateBooking() {
      if (this.showBuyerField('first_name') && !this.booking.buyer_first_name) {
        return '请填写买家名';
      }
      if (this.showBuyerField('last_name') && !this.booking.buyer_last_name) {
        return '请填写买家姓';
      }
      if (this.showBuyerField('tel') && !this.booking.buyer_tel_number) {
        return '请填写联系电话';
      }
      if (this.showBuyerField('email')) {
        if (!this.booking.buyer_Email) {
          return '请填写邮箱';
        }
        if (!this.validateEmail(this.booking.buyer_Email)) {
          return '请输入有效的邮箱';
        }
      }
      if (this.showGuideLang && !this.booking.guide_lang) {
        return '请选择导游语言';
      }

      for (let i = 0; i < this.booking.custom.length; i += 1) {
        const customer = this.booking.custom[i];
        const fields = this.getVisibleCustomFields(customer.cus_type);
        for (let j = 0; j < fields.length; j += 1) {
          const field = fields[j];
          if (!this.isRequired(field.config)) continue;
          if (!this.shouldValidateCustomerField(customer, field.key, field.config)) continue;
          if (this.isEmptyValue(customer[field.key])) {
            return this.getCustomerTitle(customer, i, 'custom') + '：请填写' + this.getFieldLabel(field.key, field.config);
          }
        }
      }

      for (let i = 0; i < this.booking.traffic.length; i += 1) {
        const traffic = this.booking.traffic[i];
        const fields = this.getVisibleTrafficFields(traffic.traffic_type);
        for (let j = 0; j < fields.length; j += 1) {
          const field = fields[j];
          if (!this.isRequired(field.config)) continue;
          if (this.isEmptyValue(traffic[field.key])) {
            return this.getTrafficTitle(traffic.traffic_type, i) + '：请填写' + this.getFieldLabel(field.key, field.config);
          }
        }
      }

      for (let i = 0; i < this.mobileDeviceFields.length; i += 1) {
        const field = this.mobileDeviceFields[i];
        if (this.isEmptyValue(this.booking.mobile_device[field.key])) {
          return '请填写' + this.getFieldLabel(field.key, field.config);
        }
      }

      return '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/shop/mixins/shopOrderSubmitMixin.js